import { css } from '@emotion/react';
import styled from '@emotion/styled';
import dart from '~/assets/img/icons/dart.svg';

interface DartItemProps {
  id: string;
  count: number;
  price: number;
  handlePurchase: () => void;
}

export default function DartItem({
  id,
  count,
  price,
  handlePurchase,
}: DartItemProps) {
  return (
    <li key={`dart_package_${id}`} onClick={handlePurchase}>
      <DartPackageItem>
        <DartCountBox>
          <DartIcon src={dart} alt='' />
          <DartCount>X {count}</DartCount>
        </DartCountBox>

        <Button>USD {price}</Button>
      </DartPackageItem>
    </li>
  );
}

export const DartPackageItem = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 8px 8px 16px;
    border: 1px solid ${theme.stroke.stroke_1};
    border-radius: 16px;
  `}
`;

export const DartCountBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
`;

export const DartIcon = styled.img`
  display: block;
  width: 24px;
  height: 22px;
`;

export const DartCount = styled.span`
  ${({ theme }) => css`
    ${theme.fontStyle.text.body16_medium}
  `}
`;

export const Button = styled.button`
  ${({ theme }) => css`
    display: block;
    width: 100px;
    height: 44px;
    padding: 8px;
    border-radius: 12px;
    background: ${theme.themeColor.main_light};
    color: ${theme.content.content_dark_1};
    ${theme.fontStyle.text.body16_bold}
  `}
`;
